import Footer from '@components/common/footer'
import NavBar from '@components/common/navbar'
import CareerGrowth from '@components/teacher-lp/career-growth'
import ClassroomWorldwide from '@components/teacher-lp/classroom-worldwide'
import TeachingPrinciples from '@components/teacher-lp/teaching-principles'
import WhoYouTeach from '@components/teacher-lp/who-you-teach'
import ApplicationSteps from '@components/teacher-lp/application-steps'
import EligibilityCriteria from '@components/teacher-lp/eligibilityCriteria'
import FirstFold from '@components/teacher-lp/first-fold'
import HowTeachingWorks from '@components/teacher-lp/how-teaching-works'
import PlatformFeatures from '@components/teacher-lp/platform-features'
import TeachingPaysGrows from '@components/teacher-lp/teaching-pays-grows'
import LearningCommunity from '@components/teacher-lp/learning-community'
import TeacherFirstStats from '@components/teacher-lp/teacher-first-stats'
import TeachingTracks from '@components/teacher-lp/teaching-tracks'
import AuthModal from '@containers/competitions/auth-modal.dynamic'
import { useSessionContext } from '@contexts/session'
import useStoreUTMParams from '@hooks/useStoreUTMParam'
import { teachPage } from '@lib/seo'
import { t } from '@lingui/macro'
import { FAQPageJsonLd, NextSeo } from 'next-seo'
import Router from 'next/router'
import { useState } from 'react'
import Faq from '@components/home/faq'
import AboutTeachers from '@components/about-us/about-teachers'
import TrustedByParents from '@components/teacher-lp/trusted-by-parents'
import TeacherStories from '@components/teacher-lp/teacher-stories'
import TeacherCommunity from '@components/teacher-lp/teacher-community'
import { TEACH_FAQS } from '@lib/data/faq'
import AboutUsCard from '@components/reviews-and-testimonials/about-us-card'

const Teach = () => {
  const [isOpen, setIsOpen] = useState(false)

  const { loggedIn } = useSessionContext()

  const handleBecomeTeacher = () => {
    if (loggedIn) return Router.push('/dashboard/')
    setIsOpen(true)
  }

  useStoreUTMParams()

  return (
    <>
      <NextSeo {...teachPage} />
      <FAQPageJsonLd
        mainEntity={TEACH_FAQS.map(
          ({ acceptedAnswerTextString, questionName }) => ({
            acceptedAnswerText: acceptedAnswerTextString,
            questionName: questionName,
          })
        )}
      />
      <AuthModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        redirectionUrl="/dashboard/"
        isUserTeacher
      />
      <NavBar
        isSticky={true}
        customCTAonClick={handleBecomeTeacher}
        customCTAText={t`Become a teacher`}
      />
      <FirstFold />
      <HowTeachingWorks handleBecomeTeacher={handleBecomeTeacher} />
      <PlatformFeatures />
      <TeachingTracks handleBecomeTeacher={handleBecomeTeacher} />
      <TeachingPaysGrows />
      <LearningCommunity />
      <TeacherFirstStats />
      <ApplicationSteps handleBecomeTeacher={handleBecomeTeacher} />
      <EligibilityCriteria handleBecomeTeacher={handleBecomeTeacher} />
      <CareerGrowth />
      <WhoYouTeach />
      <ClassroomWorldwide />
      <TeachingPrinciples handleBecomeTeacher={handleBecomeTeacher} />
      <AboutTeachers />
      <TrustedByParents />
      <TeacherStories handleBecomeTeacher={handleBecomeTeacher} />
      <TeacherCommunity />
      <div className="bg-yellow-100 bg-opacity-25">
        <AboutUsCard />
      </div>
      <div className="pb-16">
        <Faq
          faqContents={TEACH_FAQS}
          title="Frequently asked questions about Codingal"
          faqImage={{
            path: '/images/reviews-and-testimonials',
            alt: 'Teacher FAQ Image',
          }}
        />
      </div>
      <Footer />
    </>
  )
}

// TODO: Remove once getInitialProps is removed from _app.tsx
export const getStaticProps = async () => {
  return {
    props: {},
  }
}

export default Teach
